import { StoryCardTypeEnum } from '../../models';
import Cards from './Cards';
import BaseCard from './Cards/BaseCard';
const CARDS = {
    [StoryCardTypeEnum.VIDEO]: Cards.VideoCard,
    [StoryCardTypeEnum.TEXT]: Cards.TextCard,
    [StoryCardTypeEnum.RICH_TEXT]: Cards.RichTextCard,
    [StoryCardTypeEnum.QUIZ]: Cards.QuizCard,
    [StoryCardTypeEnum.LINK]: Cards.LinkCard,
    [StoryCardTypeEnum.IMAGE]: Cards.ImageCard,
    [StoryCardTypeEnum.DOWNLOAD]: Cards.DownloadCard,
    [StoryCardTypeEnum.FEEDBACK]: Cards.FeedbackCard,
    [StoryCardTypeEnum.UPSELL]: Cards.UpsellCard,
};
export const Card = ({ card, enableProgression }) => {
    const Element = CARDS[card.variant];
    if (!Element) {
        console.warn('Could not find a form for given card variant');
        return <></>;
    }
    return (<BaseCard card={card} element={Element} enableProgression={enableProgression} fullScreenOnMobile/>);
};
export default Card;
